const TRACKING_TYPES = {
  TRACK_VIEW: "trackPageView",
  TRACK_EVENT: "trackEvent"
};
export function createMatomoTracker(params) {
  return new MatomoTracker(params);
}
class MatomoTracker {
  constructor(userOptions) {
    window._paq = window._paq || [];
    if (typeof window === "undefined" || window._paq.length !== 0 || userOptions.disabled) {
      console.warn("Matomo was not initialized.");
      return;
    }
    if (!userOptions.urlBase) {
      throw new Error("Matomo urlBase is required.");
    }
    if (!userOptions.siteId) {
      throw new Error("Matomo siteId is required.");
    }
    this.initialize(userOptions);
  }
  initialize(_ref) {
    let {
      urlBase,
      siteId,
      srcUrl,
      tagManager
    } = _ref;
    const normalizedUrlBase = urlBase[urlBase.length - 1] !== "/" ? "".concat(urlBase, "/") : urlBase;
    this.pushInstructionToMatomo("setTrackerUrl", "".concat(normalizedUrlBase, "matomo.php"));
    this.pushInstructionToMatomo("setSiteId", siteId);
    //Measure time spent on a page
    this.pushInstructionToMatomo("enableHeartBeatTimer", 15);
    this.pushInstructionToMatomo("enableLinkTracking", true);
    this.addScript(srcUrl || "".concat(normalizedUrlBase, "matomo.js"));
    if (tagManager) {
      window._mtm = window._mtm || [];
      window._mtm.push({
        "mtm.startTime": new Date().getTime(),
        event: "mtm.Start"
      });
      this.addScript(tagManager);
    }
  }
  addScript(src) {
    const doc = document;
    const scriptElement = doc.createElement("script");
    const scripts = doc.getElementsByTagName("script")[0];
    scriptElement.type = "text/javascript";
    scriptElement.async = true;
    scriptElement.defer = true;
    scriptElement.src = src;
    if (scripts && scripts.parentNode) {
      scripts.parentNode.insertBefore(scriptElement, scripts);
    }
  }

  //https://developer.matomo.org/guides/spa-tracking#tracking-a-new-page-view
  trackPageView(params) {
    this.track({
      data: [TRACKING_TYPES.TRACK_VIEW],
      ...params
    });
  }
  trackEvent(params) {
    this.pushInstructionToMatomo(...[TRACKING_TYPES.TRACK_EVENT, params === null || params === void 0 ? void 0 : params.category, params === null || params === void 0 ? void 0 : params.action, params === null || params === void 0 ? void 0 : params.name]);
  }
  track(_ref2) {
    let {
      data = [],
      documentTitle = window.document.title,
      href
    } = _ref2;
    if (data.length) {
      this.pushInstructionToMatomo("setCustomUrl", href !== null && href !== void 0 ? href : window.location.href);
      this.pushInstructionToMatomo("setDocumentTitle", documentTitle);
      this.pushInstructionToMatomo(...data);
    }
  }
  pushInstructionToMatomo(name) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    window._paq.push([name, ...args]);
  }
}
export default MatomoTracker;